<header class="">
    <div class="container-fluid">
        <div class="row">  
            <div class="text-kl-white text-center mx-auto">          
                <h1 id="splitit" class="kl-display-1 txt1">
                    MILLIONPAKKEN
                </h1>
             </div> 
        </div> <!--row-->
        <div class="row two-col-lod text-center mx-auto">
            <div class="col-md-1 col-lg-3 d-none d-md-block d-lg-block d-xl-block"></div>
            <div class="col-md-5 col-lg-3">
                <div class="lodpakke">
                    <img class="img-fluid" src="../../../../assets/images/packages/favorit.png" alt="Milllionpakken lodpakke"></div>
            </div>
            <div class="col-md-5 col-lg-3 text-kl-white pad-top">
                <h3 class="sub">88% i årlig<br> vinderchance</h3>
            </div>
            <div class="col-md-1 col-lg-3 d-none d-md-block d-lg-block d-xl-block"></div>
        </div> <!--row-->
        <!--URGENCY COUNTEREN-->
        <!--Use this newer version but the responsive layout needs fixing -->
        <!-- -->
        <div *ngIf="showCounter" class="urgency mx-auto text-kl-white text-center">
            <h5>Salget til næste trækning lukker om</h5>
            <app-countdown-v2 [date]="countdownDate"></app-countdown-v2>
       </div>   
        <!--This is the older version within a box with white bg -->
        <!-- <div class="row">
            <div class="countdown col-6 col-lg-5 col-xl-3 text-kl-white text-center d-none d-md-block mx-auto mt-3">
                <h5 class="txt_counter">Vær med til næste trækning</h5> 
                <app-countdown-v2 [date]="countdownDate"></app-countdown-v2>
            </div>
        </div>  -->
        <div class="cta mx-auto text-kl-white text-center">
            <a (click)="showPage()" class="btn btn-kl-blue btn-lg mb-3 pulse">KØB HER</a>
        </div>  
        <p class="pligt-txt text-end">*Hver gevinst over 200 kr. fratrækkes <br>gevinstafgift på 15 % inden udbetaling.</p> 
    </div> <!--container-->    
</header>
